import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { GOVERNMENT_SIGMETS_LEGEND } from './government-sigmets.legend';
import { GOVERNMENT_SIGMETS_PRODUCT_DATA } from './government-sigmets.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class GovernmentSigmetsPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(GOVERNMENT_SIGMETS_PRODUCT_DATA, {
    legend: GOVERNMENT_SIGMETS_LEGEND,
    twcLayerTypes: ['vector-tile']
  });
}
